<template>
  <div>
    <!-- 搜索区域 -->
    <div class="searchBox">
      <div class="userNameSearch">
        <div class="searchTxt">任务编号：</div>
        <el-input
          placeholder="请输入任务编号"
          size="medium"
          v-model="queryInfo.taskNumber"
          @change="getTask()"
          clearable
        >
        </el-input>
      </div>
      <div class="userNameSearch">
        <div class="searchTxt">任务标题：</div>
        <el-input
          placeholder="请输入任务标题"
          size="medium"
          v-model="queryInfo.taskTitle"
          @change="getTask()"
          clearable
        >
        </el-input>
      </div>
      <div class="userNameSearch">
        <div class="searchTxt">案件编号：</div>
        <el-input
          placeholder="请输入案件编号"
          size="medium"
          v-model="queryInfo.ajNumber"
          @change="getTask()"
          clearable
        >
        </el-input>
      </div>
      <div class="userNameSearch">
        <div class="searchTxt">任务类型：</div>
        <el-select
          v-model="queryInfo.taskType"
          filterable
          clearable
          @change="getTask()"
          placeholder="请选择"
        >
          <el-option
            v-for="item in this.TaskType"
            :key="item.ttId"
            :label="item.ttName"
            :value="item.ttId"
          >
          </el-option>
        </el-select>
      </div>
    </div>

    <!-- 卡片框 -->
    <div class="bottom-bigbox">
      <!-- 左边单位人员设备卡片区域 -->
      <div class="leftBox">
        <!-- 单位人员设备树 -->

        <el-tree
          class="treeBox"
          :data="ArchInfo"
          :props="defaultTreesProps"
          show-checkbox
          default-expand-all
          :expand-on-click-node="false"
          :highlight-current="true"
          node-key="name"
          ref="navTree"
          @check-change="getCheckedDevicesNodes"
        >
          <!-- :render-content="renderContent"  -->
          <span slot-scope="{ node, data }">
            <div class="bigTree">
              <div class="leftTree">
                <div>
                  <!-- 单位图标 -->
                  <img
                    v-show="data.type == 1"
                    style="width: 24px; height: 24px; margin-right: 2px"
                    src="../../../assets/img/tree/dw.svg"
                  />
                  <!-- 人员图标 -->
                  <img
                    v-show="data.type == 2"
                    style="width: 24px; height: 24px; margin-right: 2px"
                    src="../../../assets/img/tree/ry.svg"
                  />
                  <!-- 执法仪不在线图标 -->
                  <img
                    v-show="data.type == 3 && data.status.online == false"
                    style="width: 24px; height: 24px"
                    :src="
                      data.devideType == 1
                        ? require('../../../assets/img/tree/zfy.svg')
                        : data.devideType == 2
                        ? require('../../../assets/img/tree/bkq.svg')
                        : data.devideType == 3
                        ? require('../../../assets/img/tree/aqm.svg')
                        : data.devideType == 4
                        ? require('../../../assets/img/tree/wrj.svg')
                        : data.devideType == 5
                        ? require('../../../assets/img/tree/jksxj.svg')
                        : require('../../../assets/img/tree/zngb.svg')
                    "
                  />
                  <!-- 执法仪在线图标 -->
                  <img
                    v-show="data.type == 3 && data.status.online == true"
                    style="width: 24px; height: 24px"
                    :src="
                      data.devideType == 1
                        ? require('../../../assets/img/tree/zfy_online.svg')
                        : data.devideType == 2
                        ? require('../../../assets/img/tree/bkq_online.svg')
                        : data.devideType == 3
                        ? require('../../../assets/img/tree/aqm_online.svg')
                        : data.devideType == 4
                        ? require('../../../assets/img/tree/wrj_online.svg')
                        : data.devideType == 5
                        ? require('../../../assets/img/tree/jksxj_online.svg')
                        : require('../../../assets/img/tree/zngb_online.svg')
                    "
                  />
                </div>

                <!-- 设备名称 -->
                <el-tooltip
                  v-show="data.type == 3"
                  class="item"
                  effect="dark"
                  :content="node.label"
                  placement="top"
                >
                  <div ref="nodeLabel">
                    <div v-if="node.label.length > 8">
                      {{
                        node.label.replace(
                          /(\d{3})\d*([0-9a-zA-Z]{3})/,
                          "$1***$2"
                        )
                      }}
                    </div>
                    <div v-else>
                      {{ node.label }}
                    </div>
                  </div>
                </el-tooltip>

                <!--  -->
                <!-- 单位和人员名称 -->
                <div ref="nodeLabel" v-show="data.type == 1 || data.type == 2">
                  {{ node.label }}
                </div>
              </div>
            </div>
          </span>
        </el-tree>
      </div>
      <!-- 右边单位人员设备卡片区域 -->
      <el-col :span="20">
        <el-card class="right-card">
          <!-- 增加任务按钮 -->
          <el-button
            icon="el-icon-plus"
            type="primary"
            size="small"
            class="add-btn"
            plain
            @click="AddTaskDialogVisible = true"
          >
            新增任务
          </el-button>
          <!-- 增加任务按钮 -->
          <el-button
            icon="el-icon-share"
            type="primary"
            size="small"
            class="add-btn"
            @click="sendTaskToDevices"
            v-if="sendTaskBtn"
          >
            下发任务
          </el-button>
          <!-- 任务信息表格区域 -->
          <el-table
            :data="taskList"
            :header-cell-style="{
              background: '#0395d9',
              color: '#505255',
              textAlign: 'center',
            }"
            :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
            @selection-change="handleSelectionChange"
            ref="TaskTable"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="taskNumber" label="任务编号">
            </el-table-column>
            <el-table-column prop="taskTitle" label="任务标题">
            </el-table-column>
            <el-table-column prop="taskTypeName" label="任务类型">
            </el-table-column>
            <el-table-column prop="taskContent" label="任务内容">
              <template v-slot="taskContentSlot">
                <el-tooltip class="item" effect="light" placement="bottom">
                  <div slot="content" style="max-width: 500px">
                    {{ taskContentSlot.row.taskContent }}
                  </div>
                  <span class="taskContent">{{
                    taskContentSlot.row.taskContent
                  }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="taskCreateTime" label="创建时间">
            </el-table-column>
            <el-table-column prop="taskChildrenShow" label="允许下级项目查看">
              <template v-slot="taskSlot">
                <span>{{
                  taskSlot.row.taskChildrenShow == false ? "否" : "是"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="ajNumber" label="案件编号">
            </el-table-column>

            <el-table-column label="下发设备">
              <template v-slot="slotPlId">
                <el-button
                  type="primary"
                  size="small"
                  @click="getTaskDevice(slotPlId.row.taskId)"
                  >查看下发设备</el-button
                >
              </template>
            </el-table-column>
            <el-table-column label="关联文件">
              <template v-slot="slotPlId">
                <el-button
                  type="primary"
                  size="small"
                  @click="getFileToTask(slotPlId.row)"
                  >查看关联文件</el-button
                >
              </template>
            </el-table-column>

            <el-table-column label="操作" width="130">
              <template v-slot="slot">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="修改"
                  placement="bottom-start"
                >
                  <el-button
                    type="warning"
                    size="small"
                    circle
                    icon="el-icon-edit"
                    @click="UpdateAJ(slot.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  content="删除"
                  placement="bottom-start"
                  effect="dark"
                >
                  <el-button
                    type="danger"
                    size="small"
                    circle
                    icon="el-icon-delete"
                    @click="deleteTaskByplId(slot.row.taskId)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="queryInfo.page"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </el-card>
      </el-col>
    </div>

    <!-- 添加任务信息对话框 -->
    <el-dialog
      title="新增任务"
      :visible.sync="AddTaskDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      @close="clearAddTaskDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="addTaskFormRef"
        :rules="AddTaskRules"
        :model="taskInfo"
        label-width="80px"
      >
        <el-form-item prop="taskNumber" label="任务编号">
          <el-input
            placeholder="请输入任务编号"
            v-model="taskInfo.taskNumber"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="taskTitle" label="任务标题">
          <el-input
            placeholder="请输入任务标题"
            v-model="taskInfo.taskTitle"
            clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="taskType" label="任务类型">
          <el-select
            v-model="taskInfo.taskType"
            filterable
            placeholder="请选择任务类型"
          >
            <el-option
              v-for="item in this.TaskType"
              :key="item.ttId"
              :label="item.ttName"
              :value="item.ttId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="taskContent" label="任务内容">
          <el-input
            :rows="4"
            type="textarea"
            placeholder="请输入任务内容"
            v-model="taskInfo.taskContent"
            clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="ajNumber" label="案件编号">
          <el-input
            placeholder="请输入案件编号"
            v-model="taskInfo.ajNumber"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="允许下级项目查看">
          <el-radio-group
            v-model="taskInfo.taskChildrenShow"
            style="display: flex; height: 80px; align-items: center"
          >
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="AddTaskDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="AddTask()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改任务信息对话框 -->
    <el-dialog
      title="修改案件编号"
      :visible.sync="updateTaskDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      @close="clearupdateTaskDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="updateTaskFormRef"
        :model="updatetaskInfo"
        label-width="80px"
      >
        <el-form-item prop="taskNumber" label="任务编号">
          <el-input
            placeholder="请输入任务编号"
            v-model="updatetaskInfo.taskNumber"
            clearable
            :disabled="true"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="taskTitle" label="任务标题">
          <el-input
            placeholder="请输入任务标题"
            v-model="updatetaskInfo.taskTitle"
            clearable
            :disabled="true"
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="taskType" label="任务类型">
          <el-select
            v-model="updatetaskInfo.taskType"
            filterable
            placeholder="请选择任务类型"
            :disabled="true"
          >
            <el-option
              v-for="item in this.TaskType"
              :key="item.ttId"
              :label="item.ttName"
              :value="item.ttId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="taskContent" label="任务内容">
          <el-input
            :rows="4"
            type="textarea"
            placeholder="请输入任务内容"
            v-model="updatetaskInfo.taskContent"
            clearable
            :disabled="true"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="ajNumber" label="案件编号">
          <el-input
            placeholder="请输入案件编号"
            v-model="updatetaskInfo.ajNumber"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="允许下级项目查看">
          <el-radio-group
            v-model="updatetaskInfo.taskChildrenShow"
            style="display: flex; height: 80px; align-items: center"
          >
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateTaskDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateTask()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 查看下发任务信息对话框 -->
    <el-dialog
      title="任务已下发设备"
      :visible.sync="sendDevicesDialog"
      width="50%"
      :close-on-click-modal="false"
      @close="clearsendDevicesDialogVisible()"
    >
      <el-table
        :data="sendDevicesList"
        :header-cell-style="{
          background: '#0395d9',
          color: '#505255',
          textAlign: 'center',
        }"
        :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
        :default-sort="{ prop: 'devCreatetime', order: 'descending' }"
      >
        <el-table-column prop="devEmpName" label="使用人员"> </el-table-column>
        <el-table-column prop="devNo" label="设备编号"> </el-table-column>
        <el-table-column prop="devCreatetime" sortable label="下发时间">
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot="UnissueSlot">
            <el-button
              type="warning"
              size="small"
              @click="Unissue(UnissueSlot.row.devId)"
              >解除下发</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 根据任务编号查看关联文件信息对话框 -->
    <el-dialog
      :title="'任务关联文件：' + this.taskTitle"
      :visible.sync="FileToTaskDevicesDialog"
      width="60%"
      :close-on-click-modal="false"
      @close="clearFileToTaskDevicesDialogVisible()"
    >
      <div
        class="btnTagFile"
        @click="getMedia(1)"
        :class="{ active: activeIndex === 1 }"
      >
        <i class="el-icon-video-camera"></i>视频
      </div>
      <div
        class="btnTagFile"
        @click="getMedia(2)"
        style="margin-top: 50px"
        :class="{ active: activeIndex === 2 }"
      >
        <i class="el-icon-bell"></i>音频
      </div>
      <div
        class="btnTagFile"
        @click="getMedia(3)"
        style="margin-top: 100px"
        :class="{ active: activeIndex === 3 }"
      >
        <i class="el-icon-picture-outline"></i>图片
      </div>
      <div>
        <el-empty v-if="this.fileList.length == 0" :image-size="200"></el-empty>
        <div v-else>
          <div style="margin: 0 10px 10px 0">
            <el-button
              type="primary"
              icon="el-icon-download"
              size="mini"
              style="height: 34px"
              v-show="deleteFilesBtn"
              @click="downLoadAll()"
              :disabled="this.downLoadAllBtn"
              >批量下载</el-button
            >
          </div>

          <!-- 文件详情区域 -->
          <el-descriptions size="medium">
            <el-descriptions-item label="人员姓名">{{
              MediaInfo.mediaEmpName
            }}</el-descriptions-item>
            <el-descriptions-item label="项目名称">{{
              MediaInfo.mediaDepName
            }}</el-descriptions-item>
            <el-descriptions-item label="设备编号">{{
              MediaInfo.mediaDevNo
            }}</el-descriptions-item>
            <el-descriptions-item label="拍摄时间">{{
              MediaInfo.mediaCreatetime
            }}</el-descriptions-item>
            <el-descriptions-item label="文件级别">
              {{
                MediaInfo.mediaLevel === 0
                  ? "普通"
                  : MediaInfo.mediaLevel === 1
                  ? "重点"
                  : null
              }}
            </el-descriptions-item>
            <el-descriptions-item label="文件大小">
              <span v-show="MediaInfo.mediaSize !== ''">
                <!-- 如果小于0.1KB转化成B  -->
                <span v-if="MediaInfo.mediaSize < 0.1 * 1024"
                  >{{ (MediaInfo.mediaSize / 1).toFixed(2) + "B" }}
                </span>
                <!-- //如果小于0.1MB转化成KB   -->
                <span v-else-if="MediaInfo.mediaSize < 0.1 * 1024 * 1024"
                  >{{ (MediaInfo.mediaSize / 1024).toFixed(2) + "KB" }}
                </span>
                <!-- //如果小于0.1GB转化成MB   -->
                <span v-else-if="MediaInfo.mediaSize < 0.1 * 1024 * 1024 * 1024"
                  >{{ (MediaInfo.mediaSize / (1024 * 1024)).toFixed(2) + "MB" }}
                </span>
                <!-- 其他转化成GB    -->
                <span v-else>
                  {{
                    (MediaInfo.mediaSize / (1024 * 1024 * 1024)).toFixed(2) +
                    "GB"
                  }}
                </span>
              </span>
            </el-descriptions-item>
            <el-descriptions-item label="锁定状态">{{
              MediaInfo.mediaLock === 0
                ? "未锁定"
                : MediaInfo.mediaLock === 1
                ? "锁定"
                : ""
            }}</el-descriptions-item>
            <el-descriptions-item label="文件标签">
              <span
                v-for="mediatag in MediaInfo.mediatagList"
                :key="mediatag.mtagId"
              >
                <el-tag
                  style="margin-right: 2px"
                  type="info"
                  size="small"
                  v-if="mediatag.mtagAttribute == 0"
                  >{{ mediatag.mtagName }}</el-tag
                >
                <el-tag
                  style="margin-right: 2px"
                  type="danger"
                  size="small"
                  v-if="mediatag.mtagAttribute == 1"
                  >{{ mediatag.mtagName }}</el-tag
                >
                <el-tag
                  style="margin-right: 2px"
                  type="warning"
                  size="small"
                  v-if="mediatag.mtagAttribute == 2"
                  >{{ mediatag.mtagName }}</el-tag
                >
                <el-tag
                  style="margin-right: 2px"
                  type="success"
                  size="small"
                  v-if="mediatag.mtagAttribute == 3"
                  >{{ mediatag.mtagName }}</el-tag
                >
                <el-tag
                  style="margin-right: 2px"
                  type="primary"
                  size="small"
                  v-if="mediatag.mtagAttribute == 4"
                  >{{ mediatag.mtagName }}</el-tag
                >
              </span>
            </el-descriptions-item>
            <el-descriptions-item label="文件描述">
              {{ MediaInfo.mediaRemark }}
            </el-descriptions-item>
          </el-descriptions>
          <div class="bottomBox">
            <!-- 文件列表 -->
            <el-card style="width: 30%; height: 480px; min-width: 300px">
              <!-- <ul class="infinite-list" style="overflow: auto">
                <li
                  v-for="fileItem in this.fileList"
                  :key="fileItem.mediaId"
                  class="infinite-list-item"
                  @click="getFileInfo(fileItem)"
                >
                  <span :class="{ active: FileActive === fileItem.mediaName }">
                    {{ fileItem.mediaName }}
                  </span>
                </li>
              </ul> -->
              <el-table
                ref="fileTable"
                :data="this.fileList"
                tooltip-effect="dark"
                style="width: 100%"
                height="430"
                @selection-change="handleSelectionFileChange"
              >
                <el-table-column type="selection" width="50"> </el-table-column>
                <el-table-column label="文件名">
                  <template v-slot="mediaSlot">
                    <div @click="getFileInfo(mediaSlot.row)">
                      <span
                        :class="{
                          active: FileActive === mediaSlot.row.mediaName,
                        }"
                        >{{ mediaSlot.row.mediaName }}</span
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="FileToTaskHandleSizeChange"
                @current-change="FileToTaskHandleCurrentChange"
                :current-page.sync="queryMedia.page"
                :page-size="20"
                :pager-count="5"
                layout="total, prev, pager,next"
                :total="this.Filetotal"
                small
              >
              </el-pagination>
            </el-card>
            <!-- 文件播放区域 -->

            <div style="width: 69%; height: 480px; margin-left: 10px">
              <el-image
                style="height: 500px; width: 100%"
                v-if="this.MediaInfo.mediaType == 3"
                :src="this.MediaInfo.mediaServerPath"
                :preview-src-list="[this.MediaInfo.mediaServerPath]"
              >
              </el-image>
              <easy-player
                v-if="
                  this.MediaInfo.mediaType == 1 || this.MediaInfo.mediaType == 2
                "
                fluent
                alt="无视频"
                :muted="false"
                loop
                autoplay
                isH265
                playbackRates="false"
                :video-url="this.MediaInfo.mediaServerPath"
              >
              </easy-player>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>


<script>
// 进入播放器
import EasyPlayer from "@easydarwin/easyplayer";
// 文件批量打包下载
import JSZip from "jszip";
import FileSaver from "file-saver";
var validateNumOrLetter = (rule, value, callback) => {
  // 只允许输入数字和字母
  const reg = /^[0-9a-zA-Z]*$/;
  if (value === "") {
    callback(new Error("请输入任务编号"));
  } else if (!reg.test(value)) {
    callback(new Error("只能输入数字和字母"));
  } else {
    callback();
  }
};
export default {
  data() {
    return {
      // 任务列表信息
      taskList: [],
      // 任务列表查询信息
      queryInfo: {
        // 任务编号
        taskNumber: "",
        // 任务标题
        taskTitle: "",
        // 案件编号
        ajNumber: "",
        // 任务类型
        taskType: "",
        //  当前页
        page: 1,
        //  每页显示多少条
        pageSize: 10,
      },

      //  单位总数量
      total: 0,
      // 单位人员设备树信息
      ArchInfo: [],
      // 组织架构信息显示树形控件
      defaultTreesProps: {
        children: "children",
        label: "name",
      },
      // 控制增加任务对话框的显示和隐藏
      AddTaskDialogVisible: false,
      // 控制发送任务按钮显示与隐藏
      sendTaskBtn: false,
      // 下发任务参数
      sendTaskToDevicesInfo: {
        devIds: [], //设备id
        taskIds: [], //任务id
      },
      // 任务实体
      taskInfo: {
        // 任务编号
        taskNumber: "",
        // 任务标题
        taskTitle: "",
        // 案件编号
        ajNumber: "",
        // 任务类型
        taskType: "",
        // 任务内容
        taskContent: "",
        // 是否允许下级查看
        taskChildrenShow: false,
      },
      // 任务类型
      TaskType: [],
      //控制修改任务对话框的显示和隐藏
      updateTaskDialogVisible: false,
      // 修改案件编号
      updatetaskInfo: {
        // 任务ID
        taskId: "",
        // 任务编号
        taskNumber: "",
        // 任务标题
        taskTitle: "",
        // 案件编号
        ajNumber: "",
        // 任务类型
        taskType: "",
        // 任务内容
        taskContent: "",
        // 是否允许下级查看
        taskChildrenShow: "",
      },
      // 查看下发设备对话框
      sendDevicesDialog: false,
      // 车牌下发设备
      sendDevicesList: [],
      //解除任务下发设备的任务ID
      unissueTaskId: "",
      //增加任务规则校验
      AddTaskRules: {
        taskNumber: [
          {
            required: true,
            trigger: "blur",
            validator: validateNumOrLetter,
          },
        ],
        taskTitle: [
          {
            required: true,
            message: "请输入任务标题",
            trigger: "blur",
          },
        ],
        taskType: [
          {
            required: true,
            message: "请选择任务类型",
            trigger: "blur",
          },
        ],
        taskContent: [
          {
            required: true,
            message: "请输入任务内容",
            trigger: "blur",
          },
        ],
      },
      // 根据任务编号查看对应关联视频
      FileToTaskDevicesDialog: false,
      // 文件信息
      fileList: [],
      // 总数量
      total: 0,
      // 查询文件信息
      queryMedia: {
        // 文件类型
        mediaType: "",
        // 任务编号
        taskNumber: "",
        //  当前页
        page: 1,
        //  每页显示多少条
        pageSize: 20,
      },
      // 单个文件详情
      MediaInfo: {
        mediaLevel: "", //重点标记
        mediaLock: "", //文件状态：0未锁定; 1锁定
        mediaRemark: "", //文件备注
        mtagIds: [], //标签id
        mediaEmpName: "", //人员姓名
        mediaDevNo: "", //设备编号
        mediaName: "", //文件名称
        mediaDepName: "", //单位名称
        mediaSize: "", //文件大小
        mediaServerPath: "", //文件地址
        mediaType: "", //文件类型
        mediatagList: "", //文件标签
        mediaCreatetime: "", //视频拍摄时间
      },
      activeIndex: -1, // 初始值为-1，表示没有点击文件类型的按钮
      FileActive: -1, //文件选中后的状态
      taskTitle: "", // 任务名称
      Filetotal: "", //文件总数
      // 控制批量下载按钮显示与隐藏
      deleteFilesBtn: false,
      //批量下载文件地址
      mediaServerPaths: [],
      // 批量下载按钮禁用开启状态
      downLoadAllBtn: false,
    };
  },
  components: {
    EasyPlayer,
  },
  created() {
    // 获取任务列表信息
    this.getTask();
    // 获取单位人员设备树
    this.getDepPersonDevTree();
    // 获取任务类型
    this.getTaskType();
  },
  mounted() {},
  methods: {
    // 查询任务列表信息
    async getTask() {
      const { data: res } = await this.$axios.get(`${this.$api}/task/search`, {
        params: this.queryInfo,
      });
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      if (res.data) {
        this.taskList = res.data.rows;
        // 任务总数量
        this.total = res.data.total;
      }
    },
    // 当每页显示条发生改变时触发
    handleSizeChange(size) {
      this.queryInfo.pageSize = size;
      this.getTask();
    },
    // 当当前页发生改变时触发
    handleCurrentChange(current) {
      this.queryInfo.page = current;
      this.getTask();
    },

    //  获取组织架构信息
    async getDepPersonDevTree() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/getDepPersonDevTree`
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.ArchInfo = res.data;
    },
    //  获取任务类型
    async getTaskType() {
      const { data: res } = await this.$axios.get(`${this.$api}/task/type/get`);
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.TaskType = res.data;
    },

    //获取tree选中的设备devIds
    getCheckedDevicesNodes() {
      var devices = this.$refs.navTree.getCheckedNodes();
      var devIds = [];
      for (let i = 0; i < devices.length; i++) {
        const element = devices[i];
        if (element.type == 3) {
          devIds.push(element.id);
        }
      }
      this.sendTaskToDevicesInfo.devIds = devIds;
    },
    // 获取table选中的任务信息
    handleSelectionChange(val) {
      if (val.length > 0) {
        this.sendTaskBtn = true;
      } else {
        this.sendTaskBtn = false;
      }
      var taskIds = [];
      for (let i = 0; i < val.length; i++) {
        taskIds.push(val[i].taskId);
      }
      this.sendTaskToDevicesInfo.taskIds = taskIds;
    },
    // 任务下发
    async sendTaskToDevices() {
      if (this.sendTaskToDevicesInfo.devIds.length == 0) {
        return this.$message.warning("请选择要下发的设备!");
      }
      const { data: res } = await this.$axios.post(
        `${this.$api}/task/send`,
        this.sendTaskToDevicesInfo
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      // 清空树的选中
      this.$refs.navTree.setCheckedNodes([]);
      // 清空表格选中值
      this.$refs.TaskTable.clearSelection();
      this.$message.success("任务下发成功");
    },

    // 根据任务查看对应下发的设备
    async getTaskDevice(taskId) {
      this.unissueTaskId = taskId;
      const { data: res } = await this.$axios.get(
        `${this.$api}/task/getTaskDevice`,
        {
          params: { taskId: taskId },
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.sendDevicesDialog = true;
      if (res.data.rows !== null && res.data.rows !== "") {
        this.sendDevicesList = res.data.rows;
      }
    },

    // 解除设备任务
    async Unissue(devId) {
      const confirmVal = await this.$confirm(
        "此操作将会解除此设备的任务下发, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$axios.get(`${this.$api}/task/unissue`, {
        params: { devId: devId, taskId: this.unissueTaskId },
      });
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.sendDevicesList = [];
      this.$message.success("已解除此设备的任务下发!");
      this.getTaskDevice(this.unissueTaskId);
    },
    // 关闭任务查看对应下发的设备对话框
    clearsendDevicesDialogVisible() {
      this.sendDevicesList = [];
    },

    // 添加任务
    AddTask() {
      this.$refs.addTaskFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$axios.post(
          `${this.$api}/task/add`,
          this.taskInfo
        );
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.$message.success("任务添加成功");
        this.AddTaskDialogVisible = false;
        this.getTask();
      });
    },

    // 修改案件编号打开对话框，获取原有值
    UpdateAJ(value) {
      console.log(value);
      this.updateTaskDialogVisible = true;
      this.updatetaskInfo.taskId = value.taskId;
      this.updatetaskInfo.taskNumber = value.taskNumber;
      this.updatetaskInfo.taskTitle = value.taskTitle;
      this.updatetaskInfo.taskType = value.taskType;
      this.updatetaskInfo.taskContent = value.taskContent;
      this.updatetaskInfo.ajNumber = value.ajNumber;
      this.updatetaskInfo.taskChildrenShow = value.taskChildrenShow;
    },
    // // 关闭修改任务对话框
    clearupdateTaskDialogVisible() {
      this.$refs.updateTaskFormRef.resetFields();
    },
    // 修改案件编号
    async updateTask() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/task/modfiy/${this.updatetaskInfo.taskId}`,

        {
          params: {
            ajNumber: this.updatetaskInfo.ajNumber,
            taskChildrenShow: this.updatetaskInfo.taskChildrenShow,
          },
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.$message.success("修改案件编号成功");
      this.updateTaskDialogVisible = false;
      this.getTask();
    },
    // 根据任务编号查看对应关联文件
    getFileToTask(value) {
      this.taskTitle = value.taskTitle;
      this.queryMedia.taskNumber = value.taskNumber;
      this.getMedia(1); //文件类型(默认视频)
      this.FileToTaskDevicesDialog = true;
    },
    // 获取文件信息
    async getMedia(mediaType) {
      // 清空this.MediaInfo对象里面的所有属性值
      Object.keys(this.MediaInfo).forEach((key) => (this.MediaInfo[key] = ""));
      if (mediaType != undefined) {
        // 指定选择文件类型
        this.activeIndex = mediaType;
        // 文件类型(默认视频)
        this.queryMedia.mediaType = mediaType;
      }

      const { data: res } = await this.$axios.post(
        `${this.$api}/media/search`,
        this.qs.stringify(this.queryMedia)
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      if (res.data.rows) {
        this.fileList = res.data.rows;
        this.Filetotal = res.data.total;
      }
    },

    // 当每页显示条发生改变时触发
    FileToTaskHandleSizeChange(size) {
      this.queryMedia.pageSize = size;
      this.queryMedia.mediaType;
      this.getMedia();
    },
    // 当当前页发生改变时触发
    FileToTaskHandleCurrentChange(current) {
      this.queryMedia.page = current;
      this.queryMedia.mediaType;
      this.getMedia();
    },
    // 获取单文件详情
    getFileInfo(value) {
      this.FileActive = value.mediaName;
      this.MediaInfo.mediaEmpName = value.mediaEmpName; //人员名称
      this.MediaInfo.mediaDepName = value.mediaDepName; //单位名称
      this.MediaInfo.mediaDevNo = value.mediaDevNo; //设备编号
      this.MediaInfo.mediaLevel = value.mediaLevel; //文件级别
      this.MediaInfo.mediaSize = value.mediaSize; //文件大小
      this.MediaInfo.mediaLock = value.mediaLock; //文件锁定状态
      this.MediaInfo.mediaRemark = value.mediaRemark; //文件描述
      this.MediaInfo.mediatagList = value.mediatagList; //文件标签
      this.MediaInfo.mediaType = value.mediaType; //文件类型
      this.MediaInfo.mediaServerPath = value.mediaServerPath; //文件地址
      this.MediaInfo.mediaCreatetime = value.mediaCreatetime; //视频拍摄时间
    },
    //关闭查看任务关联文件对话框
    clearFileToTaskDevicesDialogVisible() {
      // 清空this.MediaInfo对象里面的所有属性值
      Object.keys(this.MediaInfo).forEach((key) => (this.MediaInfo[key] = ""));
      this.FileActive = "";
    },
    //关闭增加任务信息
    clearAddTaskDialogVisible() {
      this.$refs.addTaskFormRef.resetFields();
      this.taskInfo.taskChildrenShow = false;
    },
    // 删除任务
    async deleteTaskByplId(taskId) {
      const confirmVal = await this.$confirm(
        "此操作将永久删除该任务, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$axios.delete(
        `${this.$api}/task/delete/` + taskId
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      // 解决element分页删除最后一页的最后一条数据以后不会跳转到前一页
      // 解决思路：判断被删除的数据是否为最后一页的最后一条数据、如果是则让页码减一，如果不是则在当前面即可
      // math.ceil向上取整
      let lastPage = Math.ceil(this.total / this.queryInfo.pageSize); //总数除以每页记录数
      // 判断当前页是否是最后一页 且 为最后一条数据
      if (
        this.queryInfo.page === lastPage &&
        this.total % this.queryInfo.pageSize === 1
      ) {
        this.queryInfo.page--; //页码-1
      }

      this.$message.success("任务删除成功");
      this.getTask();
    },

    // 获取table选中的文件信息
    handleSelectionFileChange(val) {
      if (val.length > 0) {
        this.deleteFilesBtn = true;
      } else {
        this.deleteFilesBtn = false;
      }
      // 获取选择的文件下载路径
      var mediaServerPath = [];
      for (let j = 0; j < val.length; j++) {
        mediaServerPath.push(val[j].mediaServerPath);
      }
      this.mediaServerPaths = mediaServerPath;
    },
    // 批量文件点击下载
    downLoadAll() {
      this.downLoadAllBtn = true;
      var date = new Date();
      var year = date.getFullYear(); //获取年份
      var month = date.getMonth() + 1; //获取月份
      var day = date.getDate(); //获取日期
      var hours = date.getHours(); //获取小时
      var minutes = date.getMinutes(); //获取分钟
      var seconds = date.getSeconds(); //获取秒钟
      var now =
        year +
        "年" +
        month +
        "月" +
        day +
        "日 " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      var blogTitle = now; // 下载后压缩包的命名
      var zip = new JSZip();
      var promises = [];
      let cache = {};
      let arrImg = [];
      for (let i = 0; i < this.mediaServerPaths.length; i++) {
        arrImg.push({
          path: this.mediaServerPaths[i], // 文件链接
          name: this.mediaServerPaths[i].split("/").pop(), // 文件名称
        });
      }
      for (let item of arrImg) {
        // item.path为文件链接地址
        const promise = this.getImgArrayBuffer(item.path).then((data) => {
          // 下载文件, 并存成ArrayBuffer对象(blob)
          zip.file(item.name, data, { binary: true }); // 逐个添加文件
          cache[item.name] = data;
        });
        promises.push(promise);
      }
      Promise.all(promises)
        .then(() => {
          zip.generateAsync({ type: "blob" }).then((content) => {
            // 生成二进制流
            FileSaver.saveAs(content, blogTitle); // 利用file-saver保存文件  自定义文件名
            this.downLoadAllBtn = false;
            this.$refs.fileTable.clearSelection(); //清空表格选择
          });
        })
        .catch((res) => {
          alert("文件压缩失败");
          this.downLoadAllBtn = false;
        });
    },
    //文件以流的形式获取（参数url为文件链接地址）
    getImgArrayBuffer(url) {
      return new Promise((resolve, reject) => {
        //通过请求获取文件blob格式
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.open("GET", url, true);
        xmlhttp.responseType = "blob";
        xmlhttp.onload = function () {
          if (this.status == 200) {
            resolve(this.response);
          } else {
            reject(this.status);
          }
        };
        xmlhttp.send();
      });
    },
  },
};
</script>                                                                                                                                                                                                 n 

<style lang="less" scoped>
/* 新增按钮 */
.add-btn {
  float: left;
  margin-bottom: 10px;
}

/* 搜索区域 */
.searchBox {
  border-bottom: 1px solid #0693c0;
  margin: 0 0 5px 0;
  height: 50px;
  width: 100%;
  display: flex;
  align-content: center;
  // 用户名搜索区域
  .userNameSearch {
    width: 300px;
    display: flex;
    align-items: center;
    margin-left: 30px;

    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 150px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }
}

/*下面内容区域大盒子*/
.bottom-bigbox {
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

/* 左边单位列表 */
.leftBox {
  width: 300px;
  height: calc(100vh - 159px);
  /* background-color: #001114; */
  background-image: url(../../../assets/img/dataBoard/box2.png);
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  opacity: 0.8;
  /* position: absolute; */
  /* left: 0; */
  display: flex;
  z-index: 999;
}

/* 组织架构信息列表区域 */
.treeBox {
  width: 300px;
  margin: 45px 10px 20px 10px;
  height: calc(100vh - 260px) !important;
  overflow-y: auto !important;
  overflow-x: auto !important;
  display: flex;
}

.bigTree {
  height: 26px;
  display: flex;
}
.leftTree {
  width: 95%;
  display: flex;
  vertical-align: center;
  align-items: center;
}

.rightTree {
  position: relative;
  right: 0px;
  margin-left: 5px;
  // width: 1%;
  vertical-align: center;
}
// 表格任务内容样式修改
.taskContent {
  -webkit-line-clamp: 1; /* 显示的行数 */
  display: -webkit-box; /*必须结合的属性,将对象作为弹性伸缩盒子模型显示*/
  -webkit-box-orient: vertical; /*必须结合的属性,设置或检索伸缩盒对象的子元素的排列方式*/
  overflow: hidden; /*文本会被修剪，并且剩余的部分不可见*/
  text-overflow: ellipsis; /*显示省略号来代表被修剪的文本*/
}

// 关联文件对话框旁边按钮
.btnTagFile {
  width: 100px;
  height: 40px;
  line-height: 40px;
  font-size: 1.2rem;
  border: 1px solid #03d7fc;
  background-color: #03d7fc;
  border-bottom-left-radius: 1em 1em;
  position: absolute;
  left: -6.5rem;
  text-align: center;
}

.active {
  background-color: #f0f9fb;
}

// 关联文件对话框下面文件列表及其播放区域
.bottomBox {
  margin-top: 20px;
  display: flex;
}

// 关联文件信息描述
/deep/.el-descriptions__body {
  color: #03d7fc;
  background-color: #043960;
}

// 文件列表样式
.infinite-list {
  height: 400px;
  padding: 0;
  margin: 0;
  list-style: none;
}
.infinite-list .infinite-list-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  background: #065e86;
  margin: 10px 0;
  color: #03d7fc;
}

// 下拉选择框
.el-select {
  width: 100%;
}

/deep/.el-table__body-wrapper{
  background-color: #043960;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/CombinedAction/instructionsIssued.vue